import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const PLANS = [
  { id:'1', name:'Starter', inr_m:499, inr_y:4790, usd_m:8, usd_y:77, color:'#4da8ff',
    features:['1 WhatsApp Number','1,000 Messages/Day','1,000 CRM Contacts','500 Widget Leads/Month','Bulk Sender + Auto Rotation','Tick Tracking (Sent/Delivered/Read)','Basic Analytics','GST Invoice','Email Support'],
    missing:['Auto Reply Bot','Campaign Manager','Team Members'] },
  { id:'2', name:'Growth', inr_m:999, inr_y:9590, usd_m:14, usd_y:135, color:'#00E74C', hot:true,
    features:['3 WhatsApp Numbers','3,000 Messages/Day','5,000 CRM Contacts','2,000 Widget Leads/Month','Auto Reply Bot','Campaign Manager','Advanced Analytics','2 Team Members','GST Invoice','Email Support'],
    missing:['Team Management'] },
  { id:'3', name:'Pro', inr_m:1999, inr_y:19190, usd_m:26, usd_y:250, color:'#a78bfa',
    features:['5 WhatsApp Numbers','5,000 Messages/Day','Unlimited Contacts','10,000 Widget Leads/Month','All Starter + Growth Features','Team Management (5 Members)','Priority Support','GST Invoice','Advanced Analytics'],
    missing:[] },
  { id:'4', name:'Enterprise', inr_m:4999, inr_y:47990, usd_m:62, usd_y:596, color:'#ffd700',
    features:['Unlimited Numbers','Unlimited Messages','Unlimited Everything','White Label','Unlimited Team Members','Dedicated Support Manager','Custom Features','GST Invoice','All Features'],
    missing:[] },
];

const COMPARE = [
  ['WhatsApp Numbers', '1', '3', '5', 'Unlimited'],
  ['Messages/Day', '1,000', '3,000', '5,000', 'Unlimited'],
  ['CRM Contacts', '1,000', '5,000', 'Unlimited', 'Unlimited'],
  ['Widget Leads/Month', '500', '2,000', '10,000', 'Unlimited'],
  ['Team Members', '1', '2', '5', 'Unlimited'],
  ['Bulk Sender', '✅', '✅', '✅', '✅'],
  ['Auto Rotation', '✅', '✅', '✅', '✅'],
  ['Tick Tracking', '✅', '✅', '✅', '✅'],
  ['Widget Lead Capture', '✅', '✅', '✅', '✅'],
  ['CRM + Pipeline', '✅', '✅', '✅', '✅'],
  ['Auto Reply Bot', '❌', '✅', '✅', '✅'],
  ['Campaign Manager', '❌', '✅', '✅', '✅'],
  ['Advanced Analytics', '❌', '✅', '✅', '✅'],
  ['Team Management', '❌', '❌', '✅', '✅'],
  ['White Label', '❌', '❌', '❌', '✅'],
  ['Support', 'Email', 'Email', 'Priority', 'Dedicated'],
];

const INCLUDED = ['GST Invoice (every payment)','Bank Transfer payment (Indian + US)','Automatic renewal reminders','CRM + Pipeline for all contacts','Birthday + Follow-up reminders','WhatsApp warmup mode','24/7 Auto reply (Growth+)'];

export default function Plans() {
  const [currency, setCurrency] = useState('INR');
  const [billing, setBilling] = useState('monthly');

  const getPrice = p => {
    if (currency === 'INR') return { sym: '₹', val: billing === 'monthly' ? p.inr_m : p.inr_y };
    return { sym: '$', val: billing === 'monthly' ? p.usd_m : p.usd_y };
  };

  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>

        {/* Hero */}
        <section style={{ padding: '110px 24px 72px', textAlign: 'center', position: 'relative' }}>
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.015) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.015) 1px,transparent 1px)', backgroundSize: '60px 60px', pointerEvents: 'none' }} />
          <div style={{ position: 'relative', zIndex: 1, maxWidth: 700, margin: '0 auto' }}>
            <div style={{ display: 'inline-block', background: 'rgba(0,231,76,0.08)', border: '1px solid rgba(0,231,76,0.2)', color: 'var(--green)', padding: '6px 18px', borderRadius: 100, fontSize: 12, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 20 }}>Pricing</div>
            <h1 style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 'clamp(30px,4.5vw,58px)', color: '#fff', marginBottom: 16, lineHeight: 1.1 }}>
              Simple, Transparent<br /><span style={{ color: 'var(--green)' }}>Pricing</span>
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 17, marginBottom: 40, lineHeight: 1.75 }}>No hidden fees. No contracts. Cancel anytime. All plans include CRM, Widget Lead Capture, and GST invoicing.</p>

            {/* Toggle */}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
              {[['INR', '₹ INR — India'], ['USD', '$ USD — International']].map(([c, l]) => (
                <button key={c} onClick={() => setCurrency(c)} style={{ padding: '9px 22px', borderRadius: 9, border: 'none', background: currency === c ? 'var(--green)' : 'var(--bg-card)', color: currency === c ? '#000' : 'rgba(255,255,255,0.5)', fontWeight: 600, fontSize: 13, cursor: 'pointer', transition: 'all 0.2s' }}>{l}</button>
              ))}
              {[['monthly', 'Monthly'], ['yearly', 'Yearly — Save 20%']].map(([b, l]) => (
                <button key={b} onClick={() => setBilling(b)} style={{ padding: '9px 22px', borderRadius: 9, border: 'none', background: billing === b ? 'var(--green)' : 'var(--bg-card)', color: billing === b ? '#000' : 'rgba(255,255,255,0.5)', fontWeight: 600, fontSize: 13, cursor: 'pointer', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: 6 }}>
                  {l} {b === 'yearly' && <span style={{ background: billing === 'yearly' ? '#000' : 'var(--green)', color: billing === 'yearly' ? 'var(--green)' : '#000', padding: '1px 6px', borderRadius: 4, fontSize: 10, fontWeight: 800 }}>-20%</span>}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Plan Cards */}
        <section style={{ padding: '0 24px 80px' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 20 }}>
            {PLANS.map((p, i) => {
              const { sym, val } = getPrice(p);
              return (
                <div key={p.id} style={{
                  background: p.hot ? `linear-gradient(160deg, rgba(0,231,76,0.08) 0%, var(--bg-card) 60%)` : 'var(--bg-card)',
                  border: `1px solid ${p.hot ? 'rgba(0,231,76,0.4)' : 'var(--border)'}`,
                  borderRadius: 18, padding: '28px 24px', position: 'relative',
                  animation: `fadeIn 0.5s ease ${i * 0.1}s both`,
                  transition: 'transform 0.2s, box-shadow 0.2s'
                }}
                  onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = `0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px ${p.color}30`; }}
                  onMouseOut={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                  {p.hot && <div style={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', background: 'var(--green)', color: '#000', padding: '4px 16px', borderRadius: 100, fontSize: 11, fontWeight: 800, whiteSpace: 'nowrap', boxShadow: '0 4px 12px rgba(0,231,76,0.4)' }}>⭐ Most Popular</div>}
                  <div style={{ marginBottom: 6, fontSize: 13, fontWeight: 600, color: p.color, letterSpacing: 1, textTransform: 'uppercase' }}>{p.name}</div>
                  <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 42, color: '#fff', lineHeight: 1, marginBottom: 4 }}>
                    {sym}{val.toLocaleString()}
                  </div>
                  <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', marginBottom: 24 }}>per {billing === 'monthly' ? 'month' : 'year'} · billed {billing}</div>
                  <Link to={`/register`} style={{ display: 'block', textAlign: 'center', padding: '12px', borderRadius: 10, background: p.hot ? 'var(--green)' : 'transparent', border: `1px solid ${p.hot ? 'var(--green)' : 'rgba(255,255,255,0.15)'}`, color: p.hot ? '#000' : '#fff', fontFamily: 'Sora', fontWeight: 700, fontSize: 14, marginBottom: 24, transition: 'all 0.2s' }}>
                    Get Started
                  </Link>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {p.features.map(f => (
                      <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'rgba(255,255,255,0.75)' }}>
                        <span style={{ color: 'var(--green)', fontSize: 14, flexShrink: 0 }}>✓</span> {f}
                      </div>
                    ))}
                    {p.missing.map(f => (
                      <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'rgba(255,255,255,0.2)' }}>
                        <span style={{ fontSize: 14, flexShrink: 0 }}>✗</span> {f}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* Included in all plans */}
        <section style={{ padding: '80px 24px', borderTop: '1px solid var(--border)', background: 'rgba(0,231,76,0.015)' }}>
          <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
            <h2 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 32, color: '#fff', marginBottom: 8 }}>Included in Every Plan</h2>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 15, marginBottom: 48 }}>Every MS Reach plan comes with these features — no upsells, no surprises.</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 14 }}>
              {INCLUDED.map(item => (
                <div key={item} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ color: 'var(--green)', fontWeight: 700 }}>✓</span>
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section style={{ padding: '80px 24px', borderTop: '1px solid var(--border)' }}>
          <div style={{ maxWidth: 1000, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 48 }}>
              <h2 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 32, color: '#fff', marginBottom: 8 }}>Full Feature Comparison</h2>
              <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 15 }}>See exactly what you get with each plan.</p>
            </div>
            <div style={{ overflowX: 'auto', borderRadius: 16, border: '1px solid var(--border)', overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: 'var(--bg-card2)' }}>
                    <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: 13, color: 'rgba(255,255,255,0.4)', fontWeight: 600, borderBottom: '1px solid var(--border)', width: '35%' }}>Feature</th>
                    {PLANS.map(p => (
                      <th key={p.id} style={{ padding: '16px 14px', textAlign: 'center', borderBottom: '1px solid var(--border)', borderLeft: '1px solid var(--border)' }}>
                        <div style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 14, color: p.color }}>{p.name}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {COMPARE.map(([feat, ...vals], i) => (
                    <tr key={feat} style={{ background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)', borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '13px 20px', fontSize: 13, color: 'rgba(255,255,255,0.6)', fontWeight: 500 }}>{feat}</td>
                      {vals.map((v, j) => (
                        <td key={j} style={{ padding: '13px 14px', textAlign: 'center', fontSize: 13, borderLeft: '1px solid var(--border)', color: v === '✅' ? 'var(--green)' : v === '❌' ? 'rgba(255,255,255,0.15)' : '#fff', fontWeight: v === '✅' || v === '❌' ? 700 : 500, fontSize: v === '✅' || v === '❌' ? 16 : 13 }}>
                          {v}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Annual savings */}
        <section style={{ padding: '80px 24px', borderTop: '1px solid var(--border)', textAlign: 'center' }}>
          <div style={{ maxWidth: 700, margin: '0 auto', background: 'linear-gradient(135deg, rgba(0,231,76,0.06) 0%, transparent 100%)', border: '1px solid rgba(0,231,76,0.15)', borderRadius: 20, padding: '48px 36px' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>💰</div>
            <h2 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 28, color: '#fff', marginBottom: 12 }}>Save 20% with Annual Plans</h2>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 15, lineHeight: 1.75, marginBottom: 32 }}>Pay yearly and save up to <strong style={{ color: 'var(--green)' }}>₹11,998/year</strong> on Enterprise. All plans include full GST invoicing as per Indian tax law.</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/register"><button style={{ background: 'var(--green)', color: '#000', border: 'none', padding: '12px 28px', borderRadius: 10, fontFamily: 'Sora', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>Start Now</button></Link>
              <Link to="/contact"><button style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.15)', padding: '12px 28px', borderRadius: 10, fontFamily: 'Sora', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>Talk to Sales</button></Link>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}
